import { API } from 'aws-amplify';

async function createSubcontractor(subcontractor: AddSubForm, asCompany?: string): Promise<Subcontractor> {
  try {
    const path = `/subcontractors` + (asCompany ? `?asCompany=${asCompany}` : "");
    const { data } = await API.post('api-service', path, {
      body: subcontractor,
    });
    return data;
  } catch (error: any) {
    throw error;
  }
}

export default createSubcontractor;
